'use client'

import {TabsProps} from 'antd'
import values from 'lodash/values'
import {observer} from 'mobx-react'

import {CatalogProductContent} from '@/src/core/domain/entities/catalog'
import {ServerPageData} from '@/src/core/domain/entities/page/page-data'

import {useProductViewModel} from '@/src/entities/product'

import {ProductDescription, ProductDetailCard} from '@/src/features/catalog/product-detail'
import * as UI from '@/src/features/catalog/product-detail/product-detail.styled'
import {useEffect} from 'react'
import {ProductType} from '@/src/core/domain/entities/product'
import {useRouter} from 'nextjs-toploader/app'
import {Routes} from '@/src/config/routes'

export type CatalogProductPageProps = ServerPageData<CatalogProductContent>

const ProductScreen = observer(({content}: CatalogProductPageProps) => {
  const {product} = content
  const productViewModel = useProductViewModel()
  const router = useRouter()

  useEffect(() => {
    if (product.type == ProductType.Certificate) {
      router.push(Routes.certificates.page)
    }
  }, [product.type])

  const tabs: TabsProps['items'] = []

  if (product.description) {
    tabs.push({
      label: `Описание`,
      key: '1',
      children: <ProductDescription description={product.description} />,
    })
  }

  if (Object.keys(productViewModel.cardProperties).length > 0) {
    tabs.push({
      label: `Характеристики`,
      key: '2',
      children: (
        <UI.Properties>
          <UI.PropertiesList>
            {values(productViewModel.cardProperties).map(property => (
              <UI.PropertyContainer key={property.value}>
                <UI.PropertyName>{property.title}</UI.PropertyName>
                <UI.PropertySpacer />
                <UI.PropertyValue>{property.value}</UI.PropertyValue>
              </UI.PropertyContainer>
            ))}
          </UI.PropertiesList>
        </UI.Properties>
      ),
    })
  }

  return <ProductDetailCard {...content} tabs={tabs} />
})

export default ProductScreen
